import { Component, Story, Knobs } from './DocTypes';

const BasicStoryKnobs: Knobs = {
  placeholder: { default: 'Enter a fruit', editor: 'textbox', delimiter: '\n  ' },
  value: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    delimiter: '\n  ',
  },
  doNotSuggest: { default: false, editor: 'checkbox', delimiter: '\n  ' },
  disabled: { default: false, editor: 'checkbox', delimiter: '\n  ' },
  clearButton: { default: false, editor: 'checkbox', delimiter: '\n  ' },
};
const BasicStory: Story = {
  title: 'Basic',
  description: 'A basic combobox',
  coreComponent: {
    html: `<tag-combobox
  text-field='name'
  value-field='id'{{...knobs}}
  input-disabled>
</tag-combobox>`,
    knobs: BasicStoryKnobs,
    js: `var tagCombobox = document.querySelector('tag-combobox');
  tagCombobox.componentOnReady().then(function() {
    tagCombobox.setData([
      { id: 0, name: 'Pear' },
      { id: 1, name: 'Banana' },
      { id: 2, name: 'Apple' },
      { id: 3, name: 'Orange' },
      { id: 4, name: 'Kiwi' },
      { id: 5, name: 'Strawberry' },
      { id: 6, name: 'Blackberry' },
      { id: 7, name: 'Blueberry' },
      { id: 8, name: 'Cherry' },
      { id: 9, name: 'Grape' },
      { id: 10, name: 'Grapefruit' },
    ]);
  });`,
  },
  reactWrapper: {
    jsx: `<TagCombobox
    inputDisabled
  textField='name'
  valueField='id'{{...knobs}}
  data={[
    { id: 0, name: 'Pear' },
    { id: 1, name: 'Banana' },
    { id: 2, name: 'Apple' },
    { id: 3, name: 'Orange' },
    { id: 4, name: 'Kiwi' },
    { id: 5, name: 'Strawberry' },
    { id: 6, name: 'Blackberry' },
    { id: 7, name: 'Blueberry' },
    { id: 8, name: 'Cherry' },
    { id: 9, name: 'Grape' },
    { id: 10, name: 'Grapefruit' },
  ]}
/>`,
    knobs: BasicStoryKnobs,
  },
};

const BorderlessStoryKnobs: Knobs = {
  placeholder: { default: 'Enter a fruit', editor: 'textbox', delimiter: '\n  ' },
  value: {
    default: '',
    editor: 'dropdown',
    editorOptions: ['', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
    delimiter: '\n  ',
  },
  searchable: { default: false, editor: 'checkbox', delimiter: '\n  ' },
  clearButton: { default: false, editor: 'checkbox', delimiter: '\n  ' },
};
const BorderlessStory: Story = {
  title: 'Borderless',
  description: 'A combobox that has no border which is useful for small forms',
  coreComponent: {
    html: `<tag-combobox
  borderless
  input-disabled
  text-field='name'
  value-field='id'{{...knobs}}>
</tag-combobox>`,
    knobs: BorderlessStoryKnobs,
    js: `var tagCombobox = document.querySelector('tag-combobox');
  tagCombobox.componentOnReady().then(function() {
    tagCombobox.setData([
      { id: 1, name: 'Banana' },
      { id: 2, name: 'Apple' },
      { id: 3, name: 'Orange' },
      { id: 4, name: 'Kiwi' },
      { id: 5, name: 'Strawberry' },
      { id: 6, name: 'Blackberry' },
      { id: 7, name: 'Blueberry' },
      { id: 8, name: 'Cherry' },
      { id: 9, name: 'Grape' },
      { id: 10, name: 'Grapefruit' },
    ]);
  });`,
  },
  reactWrapper: {
    jsx: `<TagCombobox
  borderless
  input-disabled
  textField='name'
  valueField='id'{{...knobs}}
  data={[
    { id: 1, name: 'Banana' },
    { id: 2, name: 'Apple' },
    { id: 3, name: 'Orange' },
    { id: 4, name: 'Kiwi' },
    { id: 5, name: 'Strawberry' },
    { id: 6, name: 'Blackberry' },
    { id: 7, name: 'Blueberry' },
    { id: 8, name: 'Cherry' },
    { id: 9, name: 'Grape' },
    { id: 10, name: 'Grapefruit' },
  ]}
/>`,
    knobs: BorderlessStoryKnobs,
  },
};

const ServerSideFilterStory: Story = {
  title: 'Server side filter',
  description:
    'A combobox where the matched items are fetched from a server as the user types into it',
  coreComponent: {
    html: `<tag-combobox
  placeholder='Enter your favourite Star Wars character'
  text-field='name'
  value-field='name'>
</tag-combobox>`,
    js: `var tagCombobox = document.querySelector('tag-combobox');
  tagCombobox.componentOnReady().then(function() {
    tagCombobox.filter = function(criteria, data) {
      return fetch('https://swapi.dev/api/people/?search=' + criteria)
        .then(function(response) {
          return response.json();
        })
        .then(function(body) {
          return {
            data: body.results,
            listOpen: body.results.length > 0,
            text: criteria,
            value: criteria,
          };
        });
    };
  });`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
    const combobox = React.useRef(null);
    React.useEffect(() => {
      combobox.current.tagComponent.current.filter = (criteria, data) => {
        return fetch('https://swapi.dev/api/people/?search=' + criteria)
          .then(function(response) {
            return response.json();
          })
          .then(function(body) {
            return {
              data: body.results,
              listOpen: body.results.length > 0,
              text: criteria,
              value: criteria,
            };
          });
        }
    }, [])
    return (
      <TagCombobox
        ref={combobox}
        placeholder='Enter your favourite Star Wars character'
        textField='name'
        valueField='name'
      />
    )
  }`,
  },
};

const LargeArrayStory: Story = {
  title: 'Large array',
  description: 'A combobox that is bound to a large array of data',
  coreComponent: {
    html: `<tag-combobox
  placeholder='Enter a number between 1 and 1000'
  text-field='number'
  value-field='number'>
</tag-combobox>`,
    js: `var tagCombobox = document.querySelector('tag-combobox');
  tagCombobox.componentOnReady().then(function() {
    var data = [];
    var i;
    for (i = 0; i < 1000; i++) {
      data.push({ number: i.toString() });
    }
    tagCombobox.setData(data);
  });`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `const Example = () => {
    const data = [];
    for (let i = 0; i < 1000; i++) {
      data.push({ number: i.toString() });
    }
    return (
      <TagCombobox
        placeholder='Enter a number between 1 and 1000'
        textField='number'
        valueField='number'
        data={data}
      />
    )
  }`,
  },
};

const IconStory: Story = {
  title: 'Icon',
  description: 'A combobox that has items containing an icon',
  coreComponent: {
    html: `<tag-combobox
  placeholder='Choose something'
  text-field='name'
  value-field='id'
  left-icon-field='icon'>
</tag-combobox>`,
    js: `var tagCombobox = document.querySelector('tag-combobox');
  tagCombobox.componentOnReady().then(function() {
    tagCombobox.setData([
      { id: 1, name: 'Apple', icon: 'Apple' },
      { id: 2, name: 'Art', icon: 'Art' },
      { id: 3, name: 'Book', icon: 'Book' },
      { id: 4, name: 'Bug', icon: 'Bug' },
      { id: 5, name: 'Calculator', icon: 'Calculator' },
      { id: 6, name: 'Code', icon: 'Code' },
      { id: 7, name: 'Duplicate', icon: 'Duplicate' },
      { id: 8, name: 'Football', icon: 'Football' },
      { id: 9, name: 'Medal', icon: 'Medal' },
      { id: 10, name: 'Ribbon', icon: 'Ribbon' },
    ]);
  });`,
  },
  reactWrapper: {
    jsx: `<TagCombobox
  placeholder='Choose something'
  textField='name'
  valueField='id'
  leftIconField='icon'
  data={[
    { id: 1, name: 'Apple', icon: 'Apple' },
    { id: 2, name: 'Art', icon: 'Art' },
    { id: 3, name: 'Book', icon: 'Book' },
    { id: 4, name: 'Bug', icon: 'Bug' },
    { id: 5, name: 'Calculator', icon: 'Calculator' },
    { id: 6, name: 'Code', icon: 'Code' },
    { id: 7, name: 'Duplicate', icon: 'Duplicate' },
    { id: 8, name: 'Football', icon: 'Football' },
    { id: 9, name: 'Medal', icon: 'Medal' },
    { id: 10, name: 'Ribbon', icon: 'Ribbon' },
  ]}
/>`,
  },
};

const MultipleBitsOfInfoStory: Story = {
  title: 'Multiple bits of info',
  description: 'A combobox that has items containing various items',
  coreComponent: {
    html: `<tag-combobox
  placeholder='Choose someone'
  text-field='name'
  value-field='id'
  primary-field='name'
  primary-field-inline
  primary-field-style='{"width": "100px", "font-size": "13px"}'
  avatar-src-field='image'
  avatar-placeholder-field='placeholder'
  secondary-field='role'
  secondary-field-inline>
</tag-combobox>`,
    js: `var tagCombobox = document.querySelector('tag-combobox');
  tagCombobox.componentOnReady().then(function() {
    tagCombobox.setData([
      {
        id: 1,
        name: 'Jack',
        role: 'UI Designer',
        placeholder: 'JK',
      },
      {
        id: 2,
        name: 'Sandra',
        role: 'UI Designer',
        image:
          'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
      },
      {
        id: 3,
        name: 'Ben',
        role: 'UI Designer',
        image:
          'https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
      },
      {
        id: 4,
        name: 'Jane',
        role: 'UI Designer',
        image:
          'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
      },
      {
        id: 5,
        name: 'Tom',
        role: 'UI Designer',
        image:
          'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
      },
      {
        id: 6,
        name: 'Chloe',
        role: 'UI Designer',
        image:
          'https://images.pexels.com/photos/324658/pexels-photo-324658.jpeg?auto=compress&cs=tinysrgb&h=350',
      },
    ]);
  });`,
  },
  reactWrapper: {
    jsx: `<TagCombobox
  placeholder='Choose someone'
  textField='name'
  valueField='id'
  primaryField='name'
  primaryFieldInline
  primaryFieldStyle={{width: "100px", fontSize: "13px"}}
  avatarSrcField='image'
  avatarPlaceholderField='placeholder'
  secondaryField='role'
  secondaryFieldInline
  data={[
    {
      id: 1,
      name: 'Jack',
      role: 'UI Designer',
      placeholder: 'JK',
    },
    {
      id: 2,
      name: 'Sandra',
      role: 'UI Designer',
      image:
        'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
    },
    {
      id: 3,
      name: 'Ben',
      role: 'UI Designer',
      image:
        'https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
    },
    {
      id: 4,
      name: 'Jane',
      role: 'UI Designer',
      image:
        'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
    },
    {
      id: 5,
      name: 'Tom',
      role: 'UI Designer',
      image:
        'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
    },
    {
      id: 6,
      name: 'Chloe',
      role: 'UI Designer',
      image:
        'https://images.pexels.com/photos/324658/pexels-photo-324658.jpeg?auto=compress&cs=tinysrgb&h=350',
    },
  ]}
/>`,
  },
};

const LimitToListStory: Story = {
  title: 'Limit to list',
  description: 'A combobox that has validation forcing the user to enter an item within the list',
  coreComponent: {
    html: `<tag-edit-field
  name="fruit"
  editor="combobox"
  placeholder="Choose a fruit">
  <tag-validation rule='inarray' args='["Banana","Apple","Orange"]'></tag-validation>
</tag-edit-field>`,
    js: `var tagCombobox = document.querySelector('tag-edit-field');
  tagCombobox.componentOnReady().then(function() {
    tagCombobox.setData(["Banana","Apple","Orange"]);
  });`,
  },
  reactWrapper: {
    jsx: `<TagEditField
  name="fruit"
  editor="combobox"
  placeholder="Choose a fruit"
  options={[{label: "Banana", value: "Banana"}, {label: "Apple", value: "Apple"}, {label: "Orange", value: "Orange"}]}
  validation={[
    { rule: 'inarray', args: '["Banana","Apple","Orange"]' }
  ]}
/>`,
  },
};

const ScrollContainerStory: Story = {
  title: 'Scroll container',
  description: 'Several comboboxes in a scroll container',
  coreComponent: {
    html: `<div style="height:250px;overflow:auto;width:300px">
  <div style="margin-bottom:15px;">
    <tag-combobox placeholder='Select something' value='2' list-width=200
      text-field='name' value-field='id'>
    </tag-combobox>
  </div>

  <div style="margin-bottom:15px;">
    <tag-combobox placeholder='Select something' value='2' list-width=400
      text-field='name' value-field='id'>
    </tag-combobox>
  </div>

  <div style="margin-bottom:15px;">
    <tag-combobox placeholder='Select something' value='2' list-width=500
      text-field='name' value-field='id'>
    </tag-combobox>
  </div>

  <div style="margin-bottom:15px;">
    <tag-combobox placeholder='Select something' value='2' list-width=100
      text-field='name' value-field='id'>
    </tag-combobox>
  </div>

  <div style="margin-bottom:15px;">
    <tag-combobox placeholder='Select something' value='2'
      text-field='name' value-field='id'>
    </tag-combobox>
  </div>

  <div style="margin-bottom:15px;">
    <tag-combobox placeholder='Select something' value='2'
      text-field='name' value-field='id'>
    </tag-combobox>
  </div>
</div>`,
    js: `var comboboxes = [].slice.call(document.querySelectorAll('tag-combobox'));
  comboboxes.forEach(function(combobox) {
    combobox.componentOnReady().then(function() {
      combobox.setData([
        { id: 1, name: 'Banana' },
        { id: 2, name: 'Apple' },
        { id: 3, name: 'Orange' },
        { id: 4, name: 'Kiwi' },
      ]);
    });
  });`,
  },
  reactWrapper: {
    jsx: `<div style={{height: "250px", overflow: "auto", width:"300px"}}>
  <div style={{marginBottom: "15px"}}>
    <TagCombobox
      placeholder='Select something'
      value='2'
      listWidth={200}
      textField='name'
      valueField='id'
      data={[
        { id: 1, name: 'Banana' },
        { id: 2, name: 'Apple' },
        { id: 3, name: 'Orange' },
        { id: 4, name: 'Kiwi' },
      ]}
    />
  </div>

  <div style={{marginBottom: "15px"}}>
    <TagCombobox
      placeholder='Select something'
      value='2'
      listWidth={400}
      textField='name'
      valueField='id'
      data={[
        { id: 1, name: 'Banana' },
        { id: 2, name: 'Apple' },
        { id: 3, name: 'Orange' },
        { id: 4, name: 'Kiwi' },
      ]}
    />
  </div>

  <div style={{marginBottom: "15px"}}>
    <TagCombobox
      placeholder='Select something'
      value='2'
      listWidth={500}
      textField='name'
      valueField='id'
      data={[
        { id: 1, name: 'Banana' },
        { id: 2, name: 'Apple' },
        { id: 3, name: 'Orange' },
        { id: 4, name: 'Kiwi' },
      ]}
    />
  </div>

  <div style={{marginBottom: "15px"}}>
    <TagCombobox
      placeholder='Select something'
      value='2'
      listWidth={100}
      textField='name'
      valueField='id'
      data={[
        { id: 1, name: 'Banana' },
        { id: 2, name: 'Apple' },
        { id: 3, name: 'Orange' },
        { id: 4, name: 'Kiwi' },
      ]}
    />
  </div>

  <div style={{marginBottom: "15px"}}>
      <TagCombobox
      placeholder='Select something'
      value='2'
      textField='name'
      valueField='id'
      data={[
        { id: 1, name: 'Banana' },
        { id: 2, name: 'Apple' },
        { id: 3, name: 'Orange' },
        { id: 4, name: 'Kiwi' },
      ]}
    />
  </div>

  <div style={{marginBottom: "15px"}}>
      <TagCombobox
      placeholder='Select something'
      value='2'
      textField='name'
      valueField='id'
      data={[
        { id: 1, name: 'Banana' },
        { id: 2, name: 'Apple' },
        { id: 3, name: 'Orange' },
        { id: 4, name: 'Kiwi' },
      ]}
    />
  </div>
</div>`,
  },
};

const CascadingStory: Story = {
  title: 'Cascading',
  description:
    'Two comboboxes where the items in the 2nd combobox is dependent on the value of the 1st combobox',
  coreComponent: {
    html: `<tag-combobox
  placeholder="Enter category"
  text-field='category'
  value-field='category'>
</tag-combobox>
<tag-combobox
  placeholder="Enter sub category"
  text-field='subCategory'
  value-field='subCategory'>
</tag-combobox>`,
    js: `var categoryData = [
  {
    category: 'Category 1',
  },
  {
    category: 'Category 2',
  },
  {
    category: 'Category 3',
  },
]
var subCategoryData = [
  {
    category: 'Category 1',
    subCategory: 'A',
  },
  {
    category: 'Category 1',
    subCategory: 'B',
  },
  {
    category: 'Category 2',
    subCategory: 'C',
  },
  {
    category: 'Category 3',
    subCategory: 'D',
  },
  {
    category: 'Category 3',
    subCategory: 'E',
  },
];

function getSubCategoryData(category) {
  return subCategoryData.filter(function(item) {
    return item.category === category;
  });
}

var categoryCombobox = document.querySelector("tag-combobox[text-field='category']");
var subCategoryCombobox = document.querySelector("tag-combobox[text-field='subCategory']");

categoryCombobox.componentOnReady().then(function() {
  categoryCombobox.setData(categoryData);
  categoryCombobox.addEventListener('valueChange', function (e) {
    subCategoryCombobox.setData(getSubCategoryData(e.detail.value));
  });
  categoryCombobox.value = "Category 1";
});

subCategoryCombobox.componentOnReady().then(function() {
  subCategoryCombobox.setData(getSubCategoryData(categoryCombobox.value));
});`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `const categoryData = [
    {
      category: 'Category 1',
    },
    {
      category: 'Category 2',
    },
    {
      category: 'Category 3',
    },
  ];
  const subCategoryData = [
    {
      category: 'Category 1',
      subCategory: 'A',
    },
    {
      category: 'Category 1',
      subCategory: 'B',
    },
    {
      category: 'Category 2',
      subCategory: 'C',
    },
    {
      category: 'Category 3',
      subCategory: 'D',
    },
    {
      category: 'Category 3',
      subCategory: 'E',
    },
  ];

  Example = () => {
    const [category, setCategory] = React.useState("Category 1")
    return (
      <React.Fragment>
        <TagCombobox
          placeholder="Enter category"
          data={categoryData}
          valueField="category"
          textField="category"
          value={category}
          onValueChange={e => setCategory(e.detail.value)}
        />
        <TagCombobox
          placeholder="Enter sub category"
          data={subCategoryData.filter(item => item.category === category)}
          valueField="subCategory"
          textField="subCategory"
        />
      </React.Fragment>
    )
  }`,
  },
};

const ClearStory: Story = {
  title: 'Clear',
  description: 'A combobox that has its value cleared when a button is clicked',
  coreComponent: {
    html: `<tag-combobox
  placeholder="Enter a fruit"
  text-field='fruit'
  value-field='fruit'>
</tag-combobox>
<tag-button text='Click to clear combobox value'></tag-button>`,
    js: `var fruitData = [
  {
    fruit: 'Banana',
  },
  {
    fruit: 'Grape',
  },
  {
    fruit: 'Apple',
  },
];

var combobox = document.querySelector("tag-combobox");
var button = document.querySelector("tag-button");

combobox.componentOnReady().then(function() {
  combobox.setData(fruitData);
});

button.addEventListener('buttonClick', function () {
  combobox.value = undefined;
});`,
  },

  reactWrapper: {
    jsx: '<Example />',
    parentJSX: `Example = () => {
    const [fruit, setFruit] = React.useState(undefined);
    return (
      <React.Fragment>
        <TagCombobox
          placeholder="Enter a fruit"
          textField='fruit'
          valueField='fruit'
          value={fruit}
          onValueChange={e => setFruit(e.detail.value)}
          data={[
            {
              fruit: 'Banana',
            },
            {
              fruit: 'Grape',
            },
            {
              fruit: 'Apple',
            },
          ]}
        />
        <TagButton
          text='Click to clear combobox value'
          onButtonClick={() => setFruit(undefined)}
        />
      </React.Fragment>
    )
  }`,
  },
};

const EllipsisStoryKnobs: Knobs = {
  inputTooltip: { default: true, editor: 'checkbox', delimiter: '\n  ' },
  primaryFieldEllipsis: { default: true, editor: 'checkbox', delimiter: '\n  ' },
  primaryFieldTitleField: { default: 'name', editor: 'textbox', delimiter: '\n  ' },
  secondaryFieldEllipsis: { default: true, editor: 'checkbox', delimiter: '\n  ' },
  secondaryFieldTitleField: { default: 'extra', editor: 'textbox', delimiter: '\n  ' },
};
const EllipsisStory: Story = {
  title: 'Tooltip and Ellipsis',
  description: 'A combobox with tooltip and ellipsis',
  coreComponent: {
    html: `<tag-combobox
  placeholder='Enter some text'
  text-field='name'
  primary-field='name'
  secondary-field='extra'
  value-field='id'
  input-style='{"text-overflow": "ellipsis", "overflow": "hidden", "white-space": "nowrap"}'
  {{...knobs}}>
</tag-combobox>`,
    knobs: EllipsisStoryKnobs,
    js: `var tagCombobox = document.querySelector('tag-combobox');
  tagCombobox.componentOnReady().then(function() {
    tagCombobox.setData([
      { id: 0,
        name: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur',
        extra: 'What Should We Do When Someone Enters A Crazy Long Amount Of Data To Try And Fit On One Line? I Think It Should Go To An Ellipsis, What Do You Think It Should Do?'
      },
      { id: 1,
        name: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio',
        extra: 'This is a special title that i want to show.'
      },
      { id: 2,
        name: 'Some text',
        extra: 'The main part of my motto is that i should make sure that the text will show an ellipsis when the text is too long. This is mainly because QA will reject my work all day every day if i dont do that because quality is really important'
      },
      { id: 3,
        name: 'Orange',
        extra: 'Orange is a fruit'
      },
    ]);
  });`,
  },
  reactWrapper: {
    jsx: `<TagCombobox
  placeholder='Enter some text'
  textField='name'
  primaryField='name'
  secondaryField='extra'
  valueField='id'
  inputStyle={{textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap"}}
  {{...knobs}}
  data={[
    { id: 0,
      name: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur',
      extra: 'What Should We Do When Someone Enters A Crazy Long Amount Of Data To Try And Fit On One Line? I Think It Should Go To An Ellipsis, What Do You Think It Should Do?'
    },
    { id: 1,
      name: 'At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio',
      extra: 'This is a special title that i want to show.'
    },
    { id: 2,
      name: 'Some text',
      extra: 'The main part of my motto is that i should make sure that the text will show an ellipsis when the text is too long. This is mainly because QA will reject my work all day every day if i dont do that because quality is really important'
    },
    { id: 3,
      name: 'Orange',
      extra: 'Orange is a fruit'
    },
  ]}
/>`,
    knobs: EllipsisStoryKnobs,
  },
};

export const TagComboboxDocs: Component = {
  type: 'component',
  name: 'combobox',
  description: 'Renders a combobox',
  mobileFriendly: false,
  popular: true,
  preRelease: '',
  props: [
    {
      name: 'id',
      description: 'The id given to the internal input',
      type: 'string',
    },
    {
      name: 'name',
      description: 'The name given to the internal input',
      type: 'string',
    },
    {
      name: 'disabled',
      description: 'Whether the component is disabled',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'inputDisabled',
      description:
        'Whether the internal input element is disabled. This prevents the user from typing into the element',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'borderless',
      description: 'Whether the internal input has its border removed',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'inputStyle',
      description: 'JSX style object in JSON to apply to the internal input',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'listWidth',
      description: 'The width of the list',
      type: 'number',
      default: 'false',
    },
    {
      name: 'listItemContainerStyle',
      description: 'The style which is applyed to the items of the list of options ',
      type: 'string',
    },
    {
      name: 'data',
      description: 'The data for the list items in the combobox',
      type: 'any[]',
    },
    {
      name: 'doNotSuggest',
      description:
        ' Whether the component should not search and suggest for the value based on what the user has entered',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'delay',
      description:
        'The delay in milliseconds after the user stops typing before the filter is invoked',
      type: 'number',
      default: '300',
    },
    {
      name: 'value',
      description: 'The selected value',
      type: 'any',
    },
    {
      name: 'textField',
      description: 'The field in the data that gives the value to show in the input',
      type: 'string',
    },
    {
      name: 'valueField',
      description: 'The field in the data that gives the actual value',
      type: 'string',
    },
    {
      name: 'imageField',
      description: 'The property name in the data item that gives an image path',
      type: 'string',
    },
    {
      name: 'leftIcon',
      description: 'The left icon name',
      type: 'string',
    },
    {
      name: 'leftIconField',
      description: 'The property name in the data item that gives an left icon name',
      type: 'string',
    },
    {
      name: 'leftIconSize',
      description: 'The left icon size',
      type: 'number',
    },
    {
      name: 'leftIconAccent',
      description: 'The left icon color',
      type: 'string',
    },
    {
      name: 'rightIcon',
      description: 'The right icon name',
      type: 'string',
    },
    {
      name: 'rightIconField',
      description: 'The property name in the data item that gives an right icon name',
      type: 'string',
    },
    {
      name: 'rightIconSize',
      description: 'The right icon size',
      type: 'number',
    },
    {
      name: 'rightIconAccent',
      description: 'The right icon color',
      type: 'string',
    },
    {
      name: 'primaryField',
      description: 'The property name in the data item that gives the primary bit of information',
      type: 'string',
    },
    {
      name: 'secondaryField',
      description: 'The property name in the data item that gives the secondary bit of information',
      type: 'string',
    },
    {
      name: 'leftLabel1',
      description: 'The label for leftField1',
      type: 'string',
    },
    {
      name: 'leftField1',
      description:
        'The property name in the data item that gives the value under the secondary value',
      type: 'string',
    },
    {
      name: 'leftLabel2',
      description: 'The label for leftField2',
      type: 'string',
    },
    {
      name: 'leftField2',
      description: 'The field under leftField1',
      type: 'string',
    },
    {
      name: 'leftLabel2',
      description: 'The label for leftField2',
      type: 'string',
    },
    {
      name: 'leftField2',
      description: 'The field under leftField1',
      type: 'string',
    },
    {
      name: 'leftLabel3',
      description: 'The label for leftField3',
      type: 'string',
    },
    {
      name: 'leftField3',
      description: 'The field under leftField2',
      type: 'string',
    },
    {
      name: 'leftLabel4',
      description: 'The label for leftField4',
      type: 'string',
    },
    {
      name: 'leftField4',
      description: 'The field under leftField3',
      type: 'string',
    },
    {
      name: 'leftLabel5',
      description: 'The label for leftField5',
      type: 'string',
    },
    {
      name: 'leftField5',
      description: 'The field under leftField4',
      type: 'string',
    },
    {
      name: 'rightLabel1',
      description: 'The label for rightField1',
      type: 'string',
    },
    {
      name: 'rightField1',
      description: 'The field in the data item that appears at the right of the list',
      type: 'string',
    },
    {
      name: 'rightLabel2',
      description: 'The label for rightField2',
      type: 'string',
    },
    {
      name: 'rightField2',
      description: 'The field under rightField1 ',
      type: 'string',
    },
    {
      name: 'rightLabel3',
      description: 'The label for rightField3',
      type: 'string',
    },
    {
      name: 'rightField3',
      description: 'The field under rightField2',
      type: 'string',
    },
    {
      name: 'rightLabel4',
      description: 'The label for rightField4',
      type: 'string',
    },
    {
      name: 'rightField4',
      description: 'The field under rightField3',
      type: 'string',
    },
    {
      name: 'rightLabel5',
      description: 'The label for rightField5',
      type: 'string',
    },
    {
      name: 'rightField5',
      description: 'The field under rightField4',
      type: 'string',
    },
    {
      name: 'primaryFieldType',
      description: 'The primary field data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'secondaryFieldType',
      description: 'The secondary field data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'leftField1Type',
      description: 'The leftField1 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'leftField2Type',
      description: 'The leftField2 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'leftField3Type',
      description: 'The leftField3 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'leftField4Type',
      description: 'The leftField4 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'leftField5Type',
      description: 'The leftField5 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'rightField1Type',
      description: 'The rightField1 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'rightField2Type',
      description: 'The rightField2 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'rightField3Type',
      description: 'The rightField3 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'rightField4Type',
      description: 'The rightField4 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'rightField5Type',
      description: 'The rightField5 data type',
      type: `'integer'| 'decimal' | 'currency' | 'date' | 'datetime' | 'boolean' | 'image' | 'email' | 'phonenumber'`,
    },
    {
      name: 'primaryFieldStyle',
      description: 'JSX style object in JSON to apply to the primary field',
      type: 'string',
    },
    {
      name: 'secondaryFieldStyle',
      description: 'JSX style object in JSON to apply to the secondary field',
      type: 'string',
    },
    {
      name: 'leftLabel1Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftLabel2Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftLabel3Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftLabel4Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftLabel5Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightLabel1Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightLabel2Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightLabel3Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightLabel4Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightLabel5Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField1Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField2Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField3Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField4Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField5Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField1Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField2Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField3Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField4Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField5Style',
      description: 'JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'primaryFieldStyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'secondaryFieldStyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField1StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField2StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField3StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField4StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'leftField5StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField1StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField2StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField3StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField4StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'rightField5StyleField',
      description: 'Field that gives JSX style object in JSON to apply',
      type: 'string',
    },
    {
      name: 'primaryFieldInline',
      description: 'Whether the primary field should be inline',
      type: 'boolean',
    },
    {
      name: 'secondaryFieldIcon',
      description: 'An icon to appear next to the secondary field',
      type: 'string',
    },
    {
      name: 'secondaryFieldIconAccent',
      description: 'The accent for the secondary icon',
      type: 'string',
    },
    {
      name: 'secondaryFieldInline',
      description: 'Whether the secondary field should be inline',
      type: 'boolean',
    },
    {
      name: 'leftField1Icon',
      description: 'An icon to appear next to left field 1',
      type: 'string',
    },
    {
      name: 'leftField1IconAccent',
      description: 'The accent for the left field 1 icon',
      type: 'string',
    },
    {
      name: 'leftField1Inline',
      description: 'Whether left field 1 should be inline',
      type: 'boolean',
    },
    {
      name: 'leftField2Icon',
      description: 'An icon to appear next to left field 2',
      type: 'string',
    },
    {
      name: 'leftField2IconAccent',
      description: 'The accent for the left field 2 icon',
      type: 'string',
    },
    {
      name: 'leftField2Inline',
      description: 'Whether left field 2 should be inline',
      type: 'boolean',
    },
    {
      name: 'leftField3Icon',
      description: 'An icon to appear next to left field 3',
      type: 'string',
    },
    {
      name: 'leftField3IconAccent',
      description: 'The accent for the left field 3 icon',
      type: 'string',
    },
    {
      name: 'leftField3Inline',
      description: 'Whether left field 3 should be inline',
      type: 'boolean',
    },
    {
      name: 'leftField4Icon',
      description: 'An icon to appear next to left field 4',
      type: 'string',
    },
    {
      name: 'leftField4IconAccent',
      description: 'The accent for the left field 4 icon',
      type: 'string',
    },
    {
      name: 'leftField4Inline',
      description: 'Whether left field 4 should be inline',
      type: 'boolean',
    },
    {
      name: 'leftField5Icon',
      description: 'An icon to appear next to left field 5',
      type: 'string',
    },
    {
      name: 'leftField5IconAccent',
      description: 'The accent for the left field 5 icon',
      type: 'string',
    },
    {
      name: 'leftField5Inline',
      description: 'Whether left field 5 should be inline',
      type: 'boolean',
    },
    {
      name: 'rightField1Icon',
      description: 'An icon to appear next to right field 1',
      type: 'string',
    },
    {
      name: 'rightField1IconAccent',
      description: 'The accent for the right field 1 icon',
      type: 'string',
    },
    {
      name: 'rightField1Inline',
      description: 'Whether right field 1 should be inline',
      type: 'boolean',
    },
    {
      name: 'rightField2Icon',
      description: 'An icon to appear next to right field 2',
      type: 'string',
    },
    {
      name: 'rightField2IconAccent',
      description: 'The accent for the right field 2 icon',
      type: 'string',
    },
    {
      name: 'rightField2Inline',
      description: 'Whether right field 2 should be inline',
      type: 'boolean',
    },
    {
      name: 'rightField3Icon',
      description: 'An icon to appear next to right field 3',
      type: 'string',
    },
    {
      name: 'rightField3IconAccent',
      description: 'The accent for the right field 3 icon',
      type: 'string',
    },
    {
      name: 'rightField3Inline',
      description: 'Whether right field 3 should be inline',
      type: 'boolean',
    },
    {
      name: 'rightField4Icon',
      description: 'An icon to appear next to right field 4',
      type: 'string',
    },
    {
      name: 'rightField4IconAccent',
      description: 'The accent for the right field 4 icon',
      type: 'string',
    },
    {
      name: 'rightField4Inline',
      description: 'Whether right field 4 should be inline',
      type: 'boolean',
    },

    {
      name: 'rightField5Icon',
      description: 'An icon to appear next to right field 5',
      type: 'string',
    },
    {
      name: 'rightField5IconAccent',
      description: 'The accent for the right field 5 icon',
      type: 'string',
    },
    {
      name: 'rightField5Inline',
      description: 'Whether right field 5 should be inline',
      type: 'boolean',
    },
    {
      name: 'filter',
      description:
        'A function to call to filter the data. This is invoked when the user stops typing',
      type:
        '(criteria: string, data: any[]) => {data: any[]; text: string; selectionStart: number; selectionEnd: number; listOpen: boolean; value: any;}',
    },
    {
      name: 'searchable',
      description: 'Whether the combobobox items are searchable',
      type: 'boolean',
    },
    {
      name: 'popupPosition',
      description: 'The popup position of the popup window',
      type:
        'auto | bottom | bottom-start | bottom-end | top | top-start | top-end | left | left-start | left-end | right | right-start | right-end',
    },
    {
      name: 'clearButton',
      description: 'When suppressed will hide the clear button (disabled by default)',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'avatarSrcField',
      description: 'The field in the data array prop that gives an avatar source ',
      type: 'string',
    },
    {
      name: 'avatarPlaceholderField',
      description: 'The field in the data array prop that gives an avatar placeholder',
      type: 'string',
    },
    {
      name: 'avatarSize',
      description: 'The size of the avatar',
      type: 'string',
    },
    {
      name: 'inputTooltip',
      description: 'Whether the input field should have tooltip',
      type: 'boolean',
    },
    {
      name: 'primaryFieldEllipsis',
      description: 'Whether the primary field should have overflow set to ellipsis',
      type: 'boolean',
    },
    {
      name: 'primaryFieldTitleField',
      description: 'The field in the data array prop that gives the title for the primary field',
      type: 'string',
    },
    {
      name: 'secondaryFieldEllipsis',
      description: 'Whether the secondary field should have overflow set to ellipsis',
      type: 'boolean',
    },
    {
      name: 'secondaryFieldTitleField',
      description: 'The field in the data array prop that gives the title for the secondary field',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'valueChange',
      description: 'Raised when the value changes',
      parameters: [
        { name: 'item', description: 'The data item behind the selected item', type: 'any' },
        { name: 'value', description: 'The selected value', type: 'any' },
        { name: 'text', description: 'The value from the input', type: 'string' },
      ],
    },
    {
      name: 'clearClicked',
      description: 'Raised when the clear button is clicked',
      parameters: [],
    },
  ],
  methods: [
    {
      name: 'setData',
      description: 'Sets the data this component',
      parameters: [
        {
          name: 'data',
          description: 'The data to bind to this component',
          type: 'any[]',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'setValue',
      description: 'Sets the value',
      parameters: [
        {
          name: 'value',
          description: 'matches on datafield or valuefield',
          type: 'any',
        },
        {
          name: 'suppressChangeEvent',
          description: 'Whether to stop the valueChange event from being raised',
          type: 'boolean',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'focusInput',
      description: 'Sets the focus to the input element of the combobox',
      parameters: [],
      returnType: 'void',
    },
    {
      name: 'select',
      description: 'Selects the text in the combobox input',
      parameters: [],
      returnType: 'void',
    },
  ],
  stories: [
    BasicStory,
    BorderlessStory,
    ServerSideFilterStory,
    LargeArrayStory,
    IconStory,
    MultipleBitsOfInfoStory,
    LimitToListStory,
    ScrollContainerStory,
    CascadingStory,
    ClearStory,
    EllipsisStory,
  ],
};
